import React from 'react';

import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/image';

import useResourcesData from '@/app/[locale]/auth/v1/(base)/iframe/(tabs)/signup/useResourcesData';
import Checkbox from '@/components/Checkbox';
import { Image as ImageType } from '@/reducers/common/commonTypes';

import styles from './VirginFamilySubscription.module.scss';

type VirginFamilyProps = {
  onChange: Function;
};

const VirginFamilySubscription = ({ onChange }: VirginFamilyProps) => {
  const resourcesData = useResourcesData();

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={(resourcesData.virginGroupAsset as unknown as ImageType)?.src}
          alt=""
          width={150}
          height={100}
          style={{ objectFit: 'contain' }}
        />
        <div>
          <h3 className={styles.virginRedHeader}>{resourcesData.virginGroupHeading} </h3>
          <p className={styles.virginRedDescription}>{resourcesData.virginGroupDescription} </p>
        </div>
      </div>
      <div>
        <Checkbox
          name="virginRed"
          label={resourcesData.virginGroupCheckbox}
          onChange={onChange}
          className={styles.virginRedCheckbox}
        />
        <div className={styles.linksContainer}>
          <p className={styles.virginRedLink}>
            {React.createElement('span', {
              dangerouslySetInnerHTML: {
                __html: DOMPurify.sanitize(resourcesData.virginGroupPrivacyPolicy, { ADD_ATTR: ['target'] }),
              },
              onMouseDown: (e) => {
                e.preventDefault();
              },
            })}
          </p>
          <p className={styles.virginRedLink}>
            {React.createElement('span', {
              dangerouslySetInnerHTML: {
                __html: DOMPurify.sanitize(resourcesData.virginGroupDataHandling, { ADD_ATTR: ['target'] }),
              },
              onMouseDown: (e) => {
                e.preventDefault();
              },
            })}
          </p>
        </div>
        <p className={styles.virginRedOptOut}>{resourcesData.virginGroupOptOutDetails} </p>
      </div>
    </div>
  );
};
export default VirginFamilySubscription;
